import { RouteConfig } from "vue-router";
import AdminUsersIndex from "@/views/admin/users/Index.vue";
import AdminCertificatesIndex from "@/views/admin/certificates/Index.vue";
import AdminClientsIndex from "@/views/admin/clients/Index.vue";
import AdminKeysIndex from "@/views/admin/keys/Index.vue";
import AdminUsersEdit from "@/views/admin/users/Edit.vue";
import AdminClientsEdit from "@/views/admin/clients/Edit.vue";
import AdminKeysEdit from "@/views/admin/keys/Edit.vue";
import AdminCertificatesCreate from "@/views/admin/certificates/Create.vue";
import AdminCertificatesEdit from "@/views/admin/certificates/Edit.vue";
import AdminKeysCsrIndex from "@/views/admin/keys/csr/Index.vue";
import AdminKeysCsrCreate from "@/views/admin/keys/csr/Create.vue";

export const adminRoutes: Array<RouteConfig> = [
  {
    path: "users",
    component: AdminUsersIndex,
    meta: {
      prefix: "/admin"
    }
  },
  {
    path: "users/:id/edit",
    component: AdminUsersEdit,
    meta: {
      prefix: "/admin"
    }
  },
  {
    path: "users/new",
    component: AdminUsersEdit,
    meta: {
      prefix: "/admin"
    }
  },
  {
    path: "certificates",
    component: AdminCertificatesIndex,
    meta: {
      prefix: "/admin"
    }
  },
  {
    path: "certificates/:fingerprint/edit",
    component: AdminCertificatesEdit,
    meta: {
      prefix: "/admin"
    }
  },
  {
    path: "certificates/new",
    component: AdminCertificatesCreate,
    meta: {
      prefix: "/admin"
    }
  },
  {
    path: "clients",
    component: AdminClientsIndex,
    meta: {
      prefix: "/admin"
    }
  },
  {
    path: "clients/:id/edit",
    component: AdminClientsEdit,
    meta: {
      prefix: "/admin"
    }
  },
  {
    path: "clients/new",
    component: AdminClientsEdit,
    meta: {
      prefix: "/admin"
    }
  },
  {
    path: "keys",
    component: AdminKeysIndex,
    meta: {
      prefix: "/admin"
    }
  },
  {
    path: "keys/:id/edit",
    component: AdminKeysEdit,
    meta: {
      prefix: "/admin"
    }
  },
  {
    path: "keys/new",
    component: AdminKeysEdit,
    meta: {
      prefix: "/admin"
    }
  },
  {
    path: "keys/:key_id/csr",
    component: AdminKeysCsrIndex,
    meta: {
      prefix: "/admin"
    }
  },
  {
    path: "keys/:key_id/csr/new",
    component: AdminKeysCsrCreate,
    meta: {
      prefix: "/admin"
    }
  },
  {
    path: "",
    redirect: "/admin/users"
  }
];
